import { createSimpleAsyncAction } from 'async-utils';
import { logger } from 'logging-utils';
import { snapshot } from 'valtio';
import {
  FilterElements,
  FilterTypeSearch,
} from '../../common/filters-utils/filters-utils';
import {
  AppPages,
  navigate,
  navigateToExclusions,
} from '../../common/routing/app-navigator';
import exclusionsService from '../services';
import {
  setExclusionsFilters,
  setSearchValues,
  setStoreExclusionsFiltersTypeSearch,
} from '../store-actions/exclusions-store-actions';
import ExclusionsStore from '../stores/exclusions-store';
import { LoadExclusionssParams } from '../types/exclusion-types';
import { loadExclusions } from './exclusions-actions';

export const loadExclusionsFilters = createSimpleAsyncAction(
  async (params?: LoadExclusionssParams) => {
    try {
      const result = await exclusionsService.getExclusionsFilters.execute(
        ExclusionsStore.filterExclusionsBy,
      );
      if (result) {
        setExclusionsFilters(result);
        setStoreExclusionsFiltersTypeSearch(result);
      }
    } catch (e) {
      logger.error(`There was an error to loading exclusions filters`, e);
    }
  },
  {
    asyncState: ExclusionsStore.loadingFilters,
    errorMessage: 'Failed to load exclusions filters',
  },
);

export const setInitialFilters = (encodedFilters: string | null) => {
  if (!encodedFilters) return;
  let filters = {};
  try {
    filters = JSON.parse(decodeURI(encodedFilters));
  } catch {}
  ExclusionsStore.filterExclusionsBy = filters;
};

export const clearFilters = () => {
  ExclusionsStore.filterExclusionsBy = {};
  ExclusionsStore.totalFilteredExclusions = 0;
  ExclusionsStore.numberOfFilters = 0;
  loadExclusions();
  navigate(AppPages.Exclusions);
};
export const toggleFiltersPanel = () => {
  ExclusionsStore.filtersOpen = !ExclusionsStore.filtersOpen;
};

export const clearFilter = (type: string) => {
  ExclusionsStore.filterExclusionsBy[type] = [];
  loadExclusions();
  loadExclusionsFilters();
};

export const onChangeFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
  if (ExclusionsStore.filterExclusionsBy[e.target.id]) {
    const index = ExclusionsStore.filterExclusionsBy[e.target.id].indexOf(
      e.target.value,
    );
    if (index !== -1) {
      if (
        Object.values(ExclusionsStore.filterExclusionsBy[e.target.id]).length >
        1
      ) {
        ExclusionsStore.filterExclusionsBy[e.target.id].splice(index, 1);
      } else {
        delete ExclusionsStore.filterExclusionsBy[e.target.id];
      }
    } else {
      ExclusionsStore.filterExclusionsBy[e.target.id].push(e.target.value);
    }
  } else {
    ExclusionsStore.filterExclusionsBy[e.target.id] = [e.target.value];
  }
  navigateToExclusions(ExclusionsStore.filterExclusionsBy);
  loadExclusions({ update: true });
  loadExclusionsFilters();
};

export const handleSearchFilterType = (
  searchInput: string,
  filterType: string,
) => {
  const { exclusionsFiltersTypes } = snapshot(ExclusionsStore);
  if (exclusionsFiltersTypes && filterType) {
    const newFilteredTypes = exclusionsFiltersTypes[filterType].filter(
      (exclusionFilterType: FilterElements) =>
        exclusionFilterType.label
          .toLocaleLowerCase()
          .includes(searchInput.toLowerCase()),
    );
    setSearchValues(filterType, searchInput);
    setStoreExclusionsFiltersTypeSearch({
      ...exclusionsFiltersTypes,
      [FilterTypeSearch[filterType]]: newFilteredTypes,
    });
  }
};
